import { useContext } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import Select from "@components/ui-components/select";
import { UserContext } from "@context/user";

// Lets a brand-workspace session switch which brand it's acting as — mirrors
// the Nook Pay Hub reference's topbar Select (persona === "brand").
const BrandSwitcher = () => {
    const { brands, activeBrandId, setActiveBrandId } = useContext(UserContext);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    if (!brands.length) return null;

    const handleChange = (nextId) => {
        setActiveBrandId(nextId);
        navigate(activeBrandId ? pathname.replace(activeBrandId, nextId) : `/brand/${nextId}/dashboard`);
    };

    return (
        <Select
            id="brand-switcher"
            size="sm"
            value={activeBrandId || ""}
            onChange={handleChange}
            options={brands.map((brand) => ({ value: brand.id, label: brand.name }))} />
    );
};

export default BrandSwitcher;
